/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INamedConfigItem, INamedConfigResolver, TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { AuthProvidersService } from "../AuthProvidersService";

/**
 * Auth Providers Params Resolver
 */
export class AuthProvidersParamsResolver implements INamedConfigResolver {
	public constructor(private authProvidersSvc: AuthProvidersService) {}

	/**
	 * Returns options schema for a given Auth providers
	 *
	 * @param name
	 */
	getOptsSchemaByName(name: string): TGenericBlueprintSchema {
		const filterAuthProviders = this.authProvidersSvc
			.getAuthProviders()
			.find((item) => item.name === name);
		return filterAuthProviders?.optionsSchema || null;
	}

	/**
	 * Return list of authProviders
	 *
	 * @return INamedConfigItem[]
	 */
	getNameList(): INamedConfigItem[] {
		return this.authProvidersSvc.getAuthProviders().map((storage) => ({
			name: storage.name,
			category: storage.category
		}));
	}
}
